<template>
    <div>
        <div class="d-flex">
            <InputText
                inputId="firstname"
                :inputLbl="localePage.firstname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[0]"
                v-model="form.fname"
                @input="onFormChange()"
            />
        </div>
        <div class="d-flex">
            <InputText
                inputId="lastname"
                :inputLbl="localePage.lastname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[1]"
                v-model="form.lname"
                @input="onFormChange()"
            />
        </div>
        <div class="d-flex position-relative">
            <InputContactNumber
                inputId="contact-number"
                addClass="register-contact-number"
                delimeter="-"
                v-model="form.contactNo"
                :inputLbl="localePage.contactnumber"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="false"
                :showLabel="true"
                :errorInfo="errorInfo[2]"
                @input="onFormChange()"
                :disabled="isHideEditContact"
            ></InputContactNumber>
            <!-- <div
                class="edit-contact-number"
                :class="{ 'show-text': form.contactNo }"
                v-if="isHideEditContact"
                @click="gotoEditPage()"
            >
                <u>แก้ไข</u>
            </div> -->
        </div>
        <div class="d-flex">
            <DropdownDatePicker
                ref="birthdate"
                :inputLbl="localePage.birthdate"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[3]"
                @onDateChange="onDatePickerSelected($event)"
                v-model="form.formatDate"
            ></DropdownDatePicker>
        </div>
        <div class="d-flex">
            <InputRadio
                v-model="form.gender"
                :setValue="form.gender"
                :inputLbl="this.localePage.gender"
                :itemList="prefixValue"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[4]"
                @input="onFormChange()"
            ></InputRadio>
        </div>
        <div class="d-flex">
            <InputProvince
                v-model="form.province"
                inputId="register-province"
                :inputLbl="this.localePage.province"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[5]"
                @input="onFormChange()"
            ></InputProvince>
        </div>
        <!-- <div class="d-flex">
            <InputTextRef
                v-model="form.refusercode"
                inputId="register-username"
                :inputLbl="lbl.register.CodeRef"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="false"
                :errorInfo="errorInfo[6]"
            ></InputTextRef>
        </div> -->
    </div>
</template>
<script>
import Moment from "moment";
// helper
import FormHelper from "@/helper/FormHelper.js";
// mixins
import LocaleMixin from "@/mixin/LocaleMixin.js";
// components
import InputText from "@/components/Input/Text.vue";
import InputContactNumber from "@/components/Input/ContactNumber.vue";
import DropdownDatePicker from "@/components/Input/DropdownDatePicker.vue";
import InputProvince from "@/components/Input/Province.vue";
import InputRadio from "@/components/Input/RadioGender.vue";
// import InputTextRef from "@/components/Input/TextRef.vue";
// import InputEmail from "@/components/Input/Email.vue";
// service
// import BzbsAddress from "@/core/Address/service/BzbsAddress.js";

export default {
    name: "FormProfile",
    props: {
        profile: Object,
        address: Object,
        isFirstSave: Boolean,
        isHideEditContact: Boolean,
        tracking: Object,
        trackingEvent: Object,
        data: Object
    },
    components: {
        InputText,
        InputContactNumber,
        DropdownDatePicker,
        InputProvince,
        InputRadio
        // InputTextRef,
        // InputEmail,
    },
    mixins: [LocaleMixin],
    data: function() {
        return {
            localePage: {},
            errorInfo: [],
            listProvince: [],
            contact: null,
            form: {
                fname: null,
                lname: null,
                gender: null,
                birthdate: null,
                contactNo: null,
                formatDate: "",
                province: null,
                email: null,
                refusercode: null
            }
        };
    },
    created() {
        this.localePage = this.lbl.profile;
        this.errorInfo = FormHelper.genErrorInfo(6);
        if (this.profile) this.mappingData();
        this.setupForm();
        if (this.data && this.data.data) {
            this.form.fname = this.data.data.FirstName;
            this.form.lname = this.data.data.LastName;
            this.form.contactNo = this.data.data.ContactNumber;
            if (this.data.data.Birthdate) {
                let date = Moment.unix(this.data.data.Birthdate).format(
                    "YYYY MM DD"
                );
                // let y = date.format("YYYY");
                // let m = date.format("M");
                // let d = date.format("D");
                this.form.formatDate = new Date(date);
            }
        }
    },
    methods: {
        setupForm() {
            var {getList,add} = FormHelper.GenderListValue();
            add("ชาย", "male", "ic_active.png", "ic_inactive.png");
            add(
                "หญิง",
                "female",
                "ic_active.png",
                "ic_inactive.png"
            );
            add(
                "ไม่ระบุ",
                "notspecified",
                "ic_active.png",
                "ic_inactive.png"
            );
            this.prefixValue = getList();

        },
        mappingData() {
            var profile = this.profile;
            this.form.fname = profile.firstName;
            this.form.lname = profile.lastName;
            this.form.gender = profile.gender;
            this.form.contactNo = profile.contactNumber;
            this.form.province = profile.province;
            if (profile.birthDate) {
                // format date
                var date = Moment.unix(profile.birthDate).utc();
                var y = date.format("YYYY");
                var m = date.format("M");
                var d = date.format("D");
                this.form.formatDate = new Date(y, m, d);
            }
        },
        onFormChange: function() {
            this.$emit("onFormChange");
        },
        onDatePickerSelected: function(data) {
            this.form.birthdate = data.timestamp.toString();
            this.onFormChange();
        },
        getFormDataFormat: function() {
            var form = this.form;
            var params = {
                register: {
                    strFirstname: form.fname,
                    strLastname: form.lname,
                    strContactNumber: form.contactNo,
                    strBirthDate: form.birthdate,
                    strEmail: form.email,
                    strRefusercode: form.refusercode,
                    strGender: form.gender,
                    strProvince: form.province
                }
            };
            return params;
        },
        isValidForm() {
            var checkError = this.errorInfo.filter(o => !o.isValid);
            if (!this.errorInfo[3].isValid) {
                var targetBirthdate = this.$refs["birthdate"];
                targetBirthdate.validateInput();
            }
            if (checkError.length !== 0) {
                return false;
            }
            return true;
        }
    }
};
</script>
<style lang="scss" scoped>
.custom-radio {
    margin: 5px 0;
    font-size: 1.7rem;
    .label {
        flex: 0 0 50px;
        padding-top: 5px;
    }
}
.wrap-input {
    width: 100%;
    margin-top: 15px;
    margin-bottom: 10px;
}
</style>
<style lang="scss">
.register-contact-number .input-box .input-field {
    background-color: rgba(0, 0, 0, 0.05) !important;
}
</style>
